import { Injectable } from '@angular/core';

// export interface OnlineUserService {
//     isOnline(uid: string) : boolean;
// }

// https://www.damirscorner.com/blog/posts/20211015-InterfacesInAngularDependencyInjection.html
export abstract class OnlineUserService {
    abstract isOnline(uid: string) : boolean;
}

@Injectable({
    providedIn: "root",
})
export class DefaultOnlineUserService implements OnlineUserService {
    isOnline(uid: string) : boolean {
        return false;
    }
}